export type SeparatorJoinItem =
  | [value?: string, separator?: string]
  | string
  | undefined
  | null;

export const separatorJoin = (
  values: SeparatorJoinItem[],
  defaultSeparator = ', '
): string => {
  const separators = values.reduce<string[]>(
    (acc, item) => {
      const [, separator = defaultSeparator] = Array.isArray(item) ? item : [];
      return [...acc, separator];
    },
    ['']
  );

  return values.reduce<string>((acc, item, index) => {
    if (!item) {
      return acc;
    }

    const [value] = typeof item === 'string' ? [item] : item;
    if (!value) {
      return acc;
    }

    return [acc, value].join(separators[index]);
  }, '');
};
